export default "__VITE_ASSET__Ke6f2uLz__"